import { createFileRoute } from "@tanstack/react-router";

import InvestorChatPage from "@/pages/Section/InvestorChatPage";

export const Route = createFileRoute("/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    founder_company_id: string;
    founder_name: string;
    initial_prompt: string | null;
  } => {
    const prompt = search.initial_prompt as string | null | undefined;
    return {
      founder_company_id: (search.founder_company_id as string) ?? "",
      founder_name: (search.founder_name as string) ?? "Deal",
      initial_prompt: prompt?.trim() ?? null,
    };
  },
  component: InvestorChatPage,
});
